enum ActivityType {
    CVE_DETECTED,
    ATTACK_TRACE_DETECTED,
    ISSUE_RESOLVED,
    STERNUM_TRIGGER_MET,
}

export default ActivityType;
